var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 153 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M5.164 16.446V2.31H.283V0h12.489v2.31h-5.06v14.136H5.164Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M13.458 16.447V4.856h2.372v1.37h.373c.196-.49.49-.842.901-1.077.412-.235.922-.333 1.55-.333h1.391V7.01h-1.49c-.784 0-1.431.216-1.921.646-.51.431-.745 1.097-.745 1.978v6.814h-2.431Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M25.83 16.78c-.824 0-1.57-.138-2.216-.431-.647-.294-1.177-.705-1.55-1.254-.391-.548-.568-1.213-.568-1.997 0-.783.196-1.468.569-1.977.392-.529.902-.92 1.568-1.194.667-.275 1.432-.392 2.275-.392h3.529v-.744c0-.666-.196-1.214-.608-1.625-.412-.411-1.04-.607-1.882-.607-.843 0-1.47.196-1.902.587a2.83 2.83 0 0 0-.863 1.528l-2.254-.725a5.09 5.09 0 0 1 .901-1.703c.412-.51.961-.92 1.667-1.234.686-.313 1.53-.47 2.49-.47 1.51 0 2.686.392 3.549 1.156.862.763 1.294 1.86 1.294 3.27v4.777c0 .47.215.704.666.704h.98v2.017h-1.803c-.55 0-1-.137-1.334-.43-.352-.275-.51-.666-.51-1.156v-.078h-.352c-.118.235-.314.509-.569.822-.255.313-.627.588-1.098.803-.49.235-1.137.333-1.921.333l-.059.02Zm.352-1.998c.98 0 1.765-.274 2.353-.842.588-.548.902-1.311.902-2.29v-.235h-3.392c-.647 0-1.157.137-1.549.41-.392.275-.588.686-.588 1.215 0 .528.196.959.608 1.272.411.314.96.47 1.666.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M35.809 16.446V4.856h2.372v1.742h.373c.215-.47.607-.9 1.176-1.312.568-.41 1.411-.607 2.51-.607.882 0 1.666.196 2.332.588.687.391 1.216.94 1.608 1.664.392.705.588 1.566.588 2.565v6.95h-2.392V9.672c-.02-.998-.274-1.742-.784-2.212-.51-.47-1.196-.725-2.078-.725-1 0-1.804.333-2.412.98-.607.665-.901 1.605-.901 2.858v5.854h-2.432l.04.02Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M55.022 16.78c-1.47 0-2.706-.334-3.666-.98-.961-.646-1.569-1.644-1.784-2.976l2.254-.548c.118.646.334 1.155.628 1.527a2.42 2.42 0 0 0 1.117.803 4.33 4.33 0 0 0 1.451.235c.765 0 1.353-.157 1.784-.45.412-.294.628-.686.628-1.155 0-.47-.197-.823-.589-1.038-.392-.216-.98-.392-1.745-.548l-.803-.138a10.946 10.946 0 0 1-2.137-.606c-.647-.274-1.157-.627-1.53-1.097-.372-.47-.568-1.077-.568-1.801 0-1.097.411-1.938 1.215-2.545.824-.607 1.902-.901 3.255-.901s2.372.294 3.215.881a3.932 3.932 0 0 1 1.627 2.389l-2.254.626c-.137-.705-.431-1.194-.902-1.488-.451-.294-1.02-.43-1.686-.43-.667 0-1.176.117-1.549.371-.372.255-.569.588-.569 1.019 0 .47.177.822.55 1.037.372.216.862.392 1.49.49l.823.137a12.44 12.44 0 0 1 2.274.587c.686.255 1.235.607 1.627 1.077.393.47.608 1.096.608 1.88 0 1.155-.431 2.055-1.294 2.701-.862.647-2.02.96-3.49.96l.02-.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M62.63 21.145V4.855h2.372V6.52h.372c.294-.51.745-.98 1.353-1.39.608-.411 1.47-.607 2.608-.607.98 0 1.862.235 2.666.705.804.47 1.45 1.155 1.96 2.036.49.88.746 1.958.746 3.21v.353c0 1.253-.236 2.33-.726 3.211-.49.881-1.137 1.566-1.96 2.036a5.292 5.292 0 0 1-2.686.705c-.745 0-1.392-.098-1.902-.274-.51-.196-.941-.43-1.255-.724-.314-.294-.569-.588-.745-.9h-.373v6.264h-2.43Zm5.999-6.48c1.058 0 1.94-.333 2.607-1.018.667-.666 1.02-1.645 1.02-2.898v-.216c0-1.233-.333-2.192-1.02-2.858-.686-.666-1.549-1.018-2.607-1.018-1.059 0-1.902.333-2.569 1.018-.686.666-1.02 1.625-1.02 2.859v.215c0 1.253.334 2.212 1.02 2.898.687.665 1.55 1.018 2.569 1.018Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M81.294 16.78c-.823 0-1.568-.138-2.215-.431-.647-.294-1.176-.705-1.549-1.254-.392-.548-.569-1.213-.569-1.997 0-.783.197-1.468.569-1.977.392-.529.902-.92 1.569-1.194.666-.275 1.43-.392 2.274-.392h3.529v-.744c0-.666-.196-1.214-.608-1.625-.412-.411-1.04-.607-1.882-.607-.843 0-1.47.196-1.902.587a2.837 2.837 0 0 0-.863 1.528l-2.254-.725a5.09 5.09 0 0 1 .902-1.703c.411-.51.96-.92 1.666-1.234.686-.313 1.53-.47 2.49-.47 1.51 0 2.686.392 3.549 1.156.862.763 1.294 1.86 1.294 3.27v4.777c0 .47.215.704.666.704h.98v2.017h-1.803c-.55 0-1-.137-1.333-.43-.353-.275-.51-.666-.51-1.156v-.078h-.353c-.118.235-.314.509-.569.822-.254.313-.627.588-1.097.803-.49.235-1.138.333-1.922.333l-.059.02Zm.353-1.998c.98 0 1.765-.274 2.353-.842.588-.548.902-1.311.902-2.29v-.235H81.51c-.647 0-1.157.137-1.549.41-.392.275-.588.686-.588 1.215 0 .528.196.959.608 1.272.411.314.96.47 1.666.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M91.273 16.447V4.856h2.373v1.37h.372c.196-.49.49-.842.902-1.077.412-.235.921-.333 1.549-.333h1.392V7.01h-1.49c-.784 0-1.431.216-1.921.646-.51.431-.746 1.097-.746 1.978v6.814h-2.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M105.272 16.78c-1.176 0-2.196-.255-3.078-.745a5.179 5.179 0 0 1-2.059-2.095c-.49-.9-.745-1.938-.745-3.132v-.274c0-1.214.236-2.252.726-3.153.49-.9 1.157-1.605 2.039-2.095.863-.49 1.882-.744 3.019-.744 1.137 0 2.098.255 2.921.744.843.49 1.49 1.175 1.961 2.056.471.881.706 1.9.706 3.074v.92h-8.921c.039 1.018.373 1.821 1.02 2.428s1.47.9 2.431.9c.902 0 1.588-.195 2.058-.606a4.37 4.37 0 0 0 1.079-1.41l2 1.038c-.216.43-.53.9-.961 1.39-.431.49-.961.9-1.627 1.214-.667.333-1.53.49-2.588.49h.019Zm-3.392-7.304h6.431c-.059-.88-.372-1.566-.941-2.056-.569-.489-1.294-.744-2.215-.744-.922 0-1.647.255-2.216.744-.568.49-.921 1.175-1.039 2.056h-.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M113.703 16.446V4.856h2.372v1.742h.373c.215-.47.607-.9 1.176-1.312.569-.41 1.412-.607 2.51-.607.882 0 1.666.196 2.333.588a4.11 4.11 0 0 1 1.607 1.664c.392.705.588 1.566.588 2.565v6.95h-2.431V9.672c0-.998-.255-1.742-.745-2.212-.509-.47-1.196-.725-2.078-.725-1 0-1.804.333-2.411.98-.608.665-.902 1.605-.902 2.858v5.854h-2.431l.039.02Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M133.563 16.78c-1.117 0-2.117-.236-3.019-.706-.902-.47-1.608-1.155-2.137-2.036-.529-.9-.784-1.958-.784-3.21v-.314c0-1.253.255-2.33.784-3.211.529-.881 1.235-1.566 2.137-2.036a6.428 6.428 0 0 1 3.019-.725c1.118 0 2.059.196 2.843.607.784.411 1.412.94 1.902 1.625.47.666.784 1.41.921 2.232l-2.352.49a3.922 3.922 0 0 0-.49-1.41 2.786 2.786 0 0 0-1.059-1.018c-.451-.254-1.02-.372-1.725-.372a3.71 3.71 0 0 0-1.824.45 3.28 3.28 0 0 0-1.274 1.312c-.314.568-.471 1.273-.471 2.075v.216c0 .822.157 1.508.471 2.095a3.166 3.166 0 0 0 1.274 1.312 3.82 3.82 0 0 0 1.824.45c1.019 0 1.803-.255 2.333-.783.529-.529.862-1.194 1.019-2.017l2.353.548a6.648 6.648 0 0 1-1 2.213 5.096 5.096 0 0 1-1.902 1.605c-.784.392-1.725.607-2.843.607Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M143.445 21.145v-2.114h6.47c.431 0 .666-.235.666-.705v-3.563h-.372c-.137.313-.353.607-.647.9-.294.294-.686.529-1.157.725-.49.195-1.098.274-1.843.274-.882 0-1.666-.196-2.353-.588a4.16 4.16 0 0 1-1.627-1.664c-.392-.724-.588-1.566-.588-2.565v-6.97h2.431v6.794c0 .999.255 1.743.745 2.213s1.196.724 2.098.724c.98 0 1.784-.333 2.392-.979.608-.646.902-1.606.902-2.859V4.895h2.431v13.96c0 .704-.216 1.272-.628 1.683-.411.431-.98.627-1.705.627h-7.196l-.019-.02Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M5.164 39.667V23.221h6.549c1 0 1.902.195 2.686.607.784.391 1.411.96 1.862 1.684.451.724.667 1.605.667 2.623v.313c0 1.018-.235 1.9-.686 2.624a4.543 4.543 0 0 1-1.863 1.684c-.784.391-1.666.587-2.666.587h-4v6.324H5.164Zm2.55-8.615h3.744c.902 0 1.608-.235 2.137-.704.53-.47.804-1.116.804-1.92v-.234c0-.822-.275-1.488-.804-1.958-.53-.47-1.255-.705-2.137-.705H7.713v5.521Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M24.182 40c-1.156 0-2.195-.235-3.097-.724-.902-.47-1.608-1.156-2.137-2.056-.51-.9-.785-1.958-.785-3.172v-.352c0-1.214.255-2.272.785-3.153a5.395 5.395 0 0 1 2.137-2.055c.901-.49 1.94-.725 3.097-.725s2.196.235 3.098.724a5.395 5.395 0 0 1 2.137 2.056c.51.881.784 1.939.784 3.153v.352c0 1.214-.255 2.271-.784 3.172a5.143 5.143 0 0 1-2.137 2.056c-.902.47-1.94.724-3.098.724Zm0-2.154c1.06 0 1.941-.332 2.608-1.018.667-.685 1-1.625 1-2.839v-.215c0-1.214-.333-2.154-.98-2.84-.647-.684-1.53-1.017-2.608-1.017s-1.902.333-2.568 1.018c-.667.685-1 1.625-1 2.839v.215c0 1.214.333 2.154 1 2.84.666.684 1.529 1.017 2.568 1.017h-.02Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M33.22 39.667v-11.59h2.373v1.37h.372c.196-.49.49-.842.902-1.077.412-.235.922-.333 1.55-.333h1.391v2.193h-1.49c-.784 0-1.431.215-1.921.646-.51.43-.745 1.097-.745 1.978v6.813H33.22Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M46.67 39.667c-.706 0-1.274-.215-1.686-.626-.412-.431-.627-.98-.627-1.684v-7.205H41.16v-2.036h3.196v-3.838h2.43v3.838h3.452v2.036h-3.451v6.794c0 .47.216.705.667.705h2.43v2.036H46.69l-.02-.02Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M56.67 40c-.824 0-1.57-.137-2.216-.43-.647-.294-1.177-.706-1.55-1.254-.391-.548-.568-1.214-.568-1.997 0-.783.196-1.468.569-1.977.392-.529.902-.92 1.568-1.195.667-.274 1.432-.391 2.275-.391h3.529v-.744c0-.666-.196-1.214-.608-1.625-.412-.412-1.04-.607-1.882-.607-.843 0-1.47.195-1.902.587-.431.392-.725.9-.863 1.527l-2.254-.724a5.09 5.09 0 0 1 .901-1.704c.412-.509.961-.92 1.667-1.233.686-.313 1.53-.47 2.49-.47 1.51 0 2.686.392 3.549 1.155.862.764 1.294 1.86 1.294 3.27v4.777c0 .47.215.705.666.705h.98v2.017h-1.803c-.55 0-1-.137-1.333-.431-.353-.274-.51-.666-.51-1.155v-.078h-.353c-.118.234-.314.509-.569.822-.255.313-.627.587-1.098.803-.49.234-1.137.332-1.921.332l-.059.02Zm.352-1.997c.98 0 1.765-.274 2.353-.842.588-.548.902-1.312.902-2.29v-.236h-3.392c-.647 0-1.157.137-1.549.412-.392.274-.588.685-.588 1.213 0 .529.196.96.608 1.273.411.313.96.47 1.666.47Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M66.649 39.667V23.221h2.43v16.446h-2.43Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.283,
    x2: 152.993,
    y1: 40,
    y2: -42.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#41A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpLogo);
export default __webpack_public_path__ + "static/media/TPLogo.49aa32532e460c8a8851aa7b8c261247.svg";
export { ForwardRef as ReactComponent };